<template>
  <div class="grid-container full">
    <div class="grid-x questionCont">
      <div class="small-11 cell">
        <div class="grid-x">
          <div class="small-12 medium-7 cell text-left no-padding jobTitleContainer">
            <p class="jobTitle" @click="toogleSlideDown" v-html="jobTitle"></p>
          </div>
          <div class="small-6 medium-3 cell no-padding">
            <span class="jobDetail" v-html="salary"></span></div>
          <div class="small-6 medium-2 cell no-padding">
            <span class="jobDetail" v-html="location"></span>
          </div>
        </div>
      </div>
      <div class="small-1 cell text-centre vertical-align-middle no-padding">
        <span class="openClose" v-if="paneOpen" @click="slideUp" >-</span>
        <span class="openClose" v-else  @click="slideDown">+</span>
      </div>

      <div v-if="paneOpen" class="small-12 cell jobDescription">

        <div class="button-container-top">
          <rare-standard-button
            class="applyButton show-for-small-only"
            style="margin-bottom: 16px"
            :active="'true'"
            :buttonText="'Apply now'"
            :height="'40px'"
            :width="'160px'"
            :fontColor="'#ffffff'"
            :fontSize="'12px'"
            @clicked="openAppForm"
          />
          <rare-standard-button
            class="applyButton show-for-medium"
            style="margin-bottom: 40px"
            :active="'true'"
            :buttonText="'Apply now'"
            :height="'64px'"
            :width="'282px'"
            :fontColor="'#ffffff'"
            :fontSize="'16px'"
            @clicked="openAppForm"
          />
        </div>

        <slot></slot>

        <div class="button-container-bottom">
        <rare-standard-button
          class="applyButton show-for-small-only"
          style="margin-bottom: 16px"
          :active="'true'"
          :buttonText="'Apply now'"
          :height="'40px'"
          :width="'160px'"
          :fontColor="'#ffffff'"
          :fontSize="'12px'"
          @clicked="openAppForm"
        />
        <rare-standard-button
          class="applyButton show-for-medium"
          style="margin-bottom: 40px"
          :active="'true'"
          :buttonText="'Apply now'"
          :height="'64px'"
          :width="'282px'"
          :fontColor="'#ffffff'"
          :fontSize="'16px'"
          @clicked="openAppForm"
        />
        </div>

      </div>

    </div>
  </div>
</template>

<script>

import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'RareWorkJobCandidateCo',
  props: {
    jobTitle: '',
    salary: '',
    location: '',
    appFormLink: '',
  },
  components: {
    'rare-standard-button': RareStandardButton,
  },
  data() {
    return {
      paneOpen: false,
    };
  },
  methods: {
    slideDown() {
      this.$root.$emit('openJobPane', true);
      this.paneOpen = true;
    },
    slideUp() {
      this.paneOpen = false;
    },
    toogleSlideDown() {
      if (this.paneOpen === true) {
        this.slideUp();
      } else {
        this.slideDown();
      }
    },
    openAppForm() {
      window.open(this.appFormLink, '_blank');
    },
  },
  mounted() {
    this.$root.$on('openJobPane', () => {
      this.slideUp();
    });
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  ul {
    margin: 0 0 16px 0;
  }
  ul {
    list-style-type: none;
  }

  ul > li:before {
    content: "- ";

  }

  p {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  .jobTitleContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .jobTitle, h2 {
    cursor: pointer;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    margin: 7px 0 0 0;
  }

  .openClose {
    font-size: 26px;
    padding: 0 10px;
    cursor: pointer;
  }

  .jobDetail {
    display: inline-block;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }

  .questionCont {
    border-bottom: 1px solid #c4cace;
  }

  @media only screen and (max-width: 640px)  {

    h3 {
      margin-top: 20px;
    }

    p, li {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: 0.2px;
      text-align: left;
    }

    .jobTitle, h2 {
      font-size: 18px;
      line-height: 1.78;
      letter-spacing: 0.2px;
    }

    .jobDetailsCont {
      border-bottom: 1px solid #c4cace;
      padding: 16px 0 16px 0;
    }

    .jobDetail {
      font-size: 14px;
      line-height: 1.52;
      letter-spacing: 0.2px;
      text-align: left;
    }

    .questionCont {
      padding: 16px 0 16px 0;
    }

    .button-container-top {
      margin-top: 20px;
    }
  }

  @media only screen and (min-width: 641px)  {

    h3 {
      margin-top: 40px;
    }

    p, li {
      font-size: 18px;
      line-height: 1.78;
      letter-spacing: 0.4px;
    }

    p {
      margin-bottom: 16px;
    }

    .jobTitle, h2 {
      font-size: 24px;
      line-height: 1;
      letter-spacing: 0.5px;
    }

    h2 {
      margin: 50px 0 16px 0;
    }

    .questionCont {
      padding: 32px 0 32px 0;
    }

    .jobDetail {
      display: block;
      font-size: 21px;
      line-height: 1.52;
      letter-spacing: 0.4px;
      text-align: center;
    }

    .jobDescription {
      padding: 40px 0 96px 0;
    }

    .button-container-bottom {
      margin-top: 90px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/workForRare/components/jobs/RareWorkJobTemplate.vue